import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../constants";
import { ShareContext } from "../context/ShareContext";
import BackLoader from "../components/backloader";
import JisButton from "../components/controls/jisButton";
import CaseSearch from "../components/core/case_search";
import JisEmptyList from "../components/controls/emptylist";
import Pagenated from "../components/pagenated";
import CaseDetails from "../components/core/caseDetails";
import JisDialog from "../components/dialog";
import JisYesNo from "../components/controls/jisYesNo";
import JisCheckbox from "../components/controls/jisCheckbox";
import JisDialogForm from "../components/formdialog";
import MultiSelectDropdown from "../components/controls/multiselectdropdown";
import DeadlineBadge from "../components/controls/deadlinebadge";
import JisTabButton from "../components/controls/jisTabButton";
import PdfViewer from "../components/controls/pdfviewer";
import CustomSearchSortHeader from "../components/core/CustomSearchSortHeader";
import ClearOptionsModal from "../components/clearOptionsModal";

function ACRScreen() {
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData, setIsExpired, setAlert, holidays } =
    useContext(ShareContext);
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState(null);
  const [err, setErr] = useState("");
  const [isPreview, setIsPreview] = useState(false);
  const [count, setCount] = useState(0);
  const [active, setActive] = useState(null);
  const [index, setIndex] = useState(-1);
  const [openCase, setOpenCase] = useState(false);
  const [isLiti, setIsLitiation] = useState(null);
  const [isRework, setIsRework] = useState(null);
  const [openOption, setOpenOption] = useState(false);
  const [comment, setComment] = useState("");
  const [option, setOption] = useState({});
  const [suitNumber, setSuitnumber] = useState("");
  const [selected, setSelected] = useState(new Set()); //to hold the selected
  const [processMode, setProcessMode] = useState("");
  const [selectedClaimTypes, setSelectedClaimTypes] = useState([]);
  const [tab, setTab] = useState("pending");
  const [documents, setDocuments] = useState([]);
  const [isDocPreview, setIsDocPreview] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");

  const [selectedGaz, setSelectedGaz] = useState(null);
  const [gazettes, setGazettes] = useState([]);
  const [missingDocs, setMissingDocs] = useState([]);
  const [showOmittedDocs, setShowOmittedDocs] = useState(false);
  const [causeOfActions, setCauseOfActions] = useState([]);
  const [isScreened, setIsScreened] = useState(false);
  useEffect(() => {
    if (pageIndex >= 0) {
      if (search != null) {
        onSearch(search);
      }
    } else {
      setPageIndex(0);
    }
  }, [pageIndex, pageSize, search, tab]);

  useEffect(() => {
    if (isRework == true) {
      onLoadDocuments();
      onLoadGazette();
    }
  }, [isRework]);
  // const onGetCauseOfAction = async (id) => {
  //   //for account registration
  //   try {
  //     const resp = await fetch(
  //       `${Constants.apiUrl}/filing/caause-of-action-by-cat/${id}`,
  //       {
  //         method: "GET",
  //         headers: { "Content-Type": "application/json", Authorization: "" },
  //       },
  //     );
  //     const data = await resp.json();

  //     setCauseOfActions(data);
  //   } catch (error) {
  //     // setLocs({ ...locs, lga: null });
  //     console.error(error);
  //   }
  // };
  // useEffect(() => {
  //   if (option.caseCategoryId) {
  //     onGetCauseOfAction(option.caseCategoryId);
  //   }
  // }, [option.caseCategoryId]);

  // const claimTypes = frequentData?.selectedClaimTypes || [];
  const claimTypes = [
    { id: 1, title: "Mortgage" },
    { id: 2, title: "Liquidated Damage" },
    { id: 3, title: "Foreigner Involved" },
    { id: 4, title: "Non Capital Offense" },
    { id: 5, title: "Non Capital Offense" },
    { id: 6, title: "Other" },
    { id: 7, title: "None" },
  ];

  console.log(frequentData, " frequentData");
  console.log(claimTypes, "claim type");
  console.log(option, " selectedClaimTypes");
  const onCheck = (value, id) => {
    let sel = selected;
    if (value) {
      sel.add(id);
    } else {
      sel.delete(id);
    }
    setSelected(new Set(sel));
  };
  const onSearch = async (sear) => {
    setSearch(sear);
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/acrs/${tab}/${pageIndex}/${pageSize}`,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setCases(data.items);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onAddMissingDoc = (gazid) => {
    // check if it already exists
    console.log(active);
    const gazExist = missingDocs.find((d) => d.id == gazid);
    console.log(` selected id ${gazid}`);
    console.log(gazExist);

    if (!gazExist) {
      const newGaz = gazettes.find((d) => d.id == gazid);
      console.log(` selected id ${gazid} inside`);
      console.log(newGaz);
      if (!newGaz) return;

      setMissingDocs((prev) => [...prev, { ...newGaz }]);
    }
  };

  const onLoadDocuments = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/case-details/${active?.caseId}/documents`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setDocuments(data.documents);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onPagePick = (pick) => {
    console.log("this is selection value");
    setPageIndex(pick.id - 1);
    console.log(pick);
  };

  const onContinue = (fee, ind) => {
    //navigate(`/case-details/${caseid}`)
    setActive(fee);
    setIndex(ind);
    setOpenCase(true);
  };

  const onCloseOpenCase = () => {
    setActive(null);
    setIndex(-1);
    setOpenCase(false);
  };
  const onAdrLitigation = (cc, ind) => {
    //can load the option for filing type and display

    setActive(cc);
    setIndex(ind);
    setOpenOption(true);
    setOption({
      caseId: cc.caseId,
      caseCategoryId: cc.caseCategoryId,
      divisionId: cc.divisionId,
    });
    setSuitnumber("");
    setProcessMode(cc.processType);
    setIsScreened(cc.isScreened);
  };

  const onSave = async (e, isScreener) => {
    e.preventDefault();

    if (isLiti == null) {
      setErr("Please select the Approval Option");
      return;
    }
    if (isLiti == false && isRework == null) {
      setErr("Please select the Reject Option");
      return;
    }
    if (isLiti == true && suitNumber == "" && !isScreener) {
      setErr("Please generate Suit Number to Preview first");
      return;
    }

    var claimtypes = Array.from(selected);
    setErr("");

    var approve = {
      ...option,
      isLitigation: isLiti,
      suitNumber: suitNumber,
      source: "acr",
      claimtypes: claimtypes,
      processType: processMode,
      comment: option.comment || "",
    };

    console.log("Option object:", option);
    console.log("Approve payload:", approve);

    if (isRework == true) {
      const rw = documents
        .filter((d) => d.isLegal || d.isCfo)
        .map((d) => ({
          docid: d.id,
          isLegal: d.isLegal || false,
          isCfo: d.isCfo || false,
          comment: d.comment || "",
          docTitle: d.title || "",
        }));

      approve.reworks = rw;
      if (showOmittedDocs && missingDocs.length > 0) {
        approve.MissingGazetteIds = missingDocs.map((d) => ({
          id: d.id,
          title: d.title,
          itemType: d.itemType,
          perItem: d.fee,
          qty: 1,
          isUpload:d.isUpload,
          associatedLineId: d.associatedLineId || null,
        }));
      }
    }

    setLoading(true);

    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/adr-litigation-approval`,
        {
          method: "POST",
          body: JSON.stringify(approve),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setOpenOption(false);
        const ft = cases.filter((_, i) => i !== index);
        setCases(ft);
        if (isLiti == false) {
          setAlert({
            open: true,
            // title: "Option",
            subtitle: "rejected successfully",
          });
        } else {
          if(suitNumber != ""){
            setAlert({
                open: true,
                // title: "Option",
                subtitle: "Suit Number Assigned Successfully",
              });
          }else{
             setAlert({
              open: true,
              // title: "Option",
              subtitle: "Case cleared to Screener.",
            });
          }
         
        }
        setIsRework(null);
        setOption({});
        setMissingDocs([])
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onGenerateNumber = async (e) => {
    e.preventDefault();
    if (isLiti == null) {
      setErr("Please select the ADR/Litigation option");
      return;
    }
    if (
      option.divisionId == "" ||
      option.subCategoryId == "" ||
      option.caseCategoryId == ""
    ) {
      setErr(
        "Please select from the options of Classification and sub Classification",
      );
      return;
    }
    setErr("");
    var approve = { ...option, isLitigation: isLiti, source: "acr" };

    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/generate-suit-number`,
        {
          method: "POST",
          body: JSON.stringify(approve),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setSuitnumber(data.suit);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };
  const onOptionChange = (e) => {
    console.log("onOptionChange called:", e.target.name, e.target.value);
    setOption({ ...option, [e.target.name]: e.target.value });
  };
  const onChangeTab = (t) => {
    setTab(t);
    setPageIndex(0);
  };
  const onPreviewDoc = (docs) => {
    setIsDocPreview(true);
    console.log(docs);
    console.log("here is called");
    var finalpath = "";
    if (docs.documentLocation != null) {
      finalpath = Constants.RelativeFiletoRelative(
       Constants.getDocumentPath(docs)
      );
    } else {
      finalpath = `${Constants.baseurl}/template-live-document/${docs.id}`;
    }
    setPreviewUrl(finalpath);
  };
  const rework_handleChange = (id, field, value) => {
    setDocuments((prev) =>
      prev.map((d) => (d.id === id ? { ...d, [field]: value } : d)),
    );
  };

  const handleViewClick = (caseid) => {
    navigate(`/case-details/${caseid}`);
  };

  const onLoadGazette = async () => {
    //for account registration
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/setup/gazette-for-rework/${active.caseFilingId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();

      console.log(data);
      if (data.code === 0) {
        setGazettes(data.gazettes);
      } else {
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      {/* <CaseSearch onSearch={onSearch} frequentData={frequentData} /> */}
      <CustomSearchSortHeader onSearch={onSearch} frequentData={frequentData} />

      <div className="tab_body">
        <div className="tab_section">
          <JisTabButton
            isActive={tab == "pending"}
            title="Pending"
            isRoleBased={false}
            onClick={() => onChangeTab("pending")}
          />

          <JisTabButton
            isActive={tab == "rework"}
            title="Rework Cases"
            isRoleBased={false}
            onClick={() => onChangeTab("rework")}
          />

          <JisTabButton
            isActive={tab == "reject"}
            title="Rejected Cases"
            isRoleBased={false}
            onClick={() => onChangeTab("reject")}
          />

          <JisTabButton
            isActive={tab == "processed"}
            title="Processed Cases"
            isRoleBased={false}
            onClick={() => onChangeTab("processed")}
          />
        </div>
        <div className="tab_view"></div>
      </div>

      {cases?.length == 0 && <JisEmptyList />}
      {cases?.length > 0 && (
        <div className="table">
          <div class="section-cases">
            <span>ACR Cases </span>
            {/* <span className="total">{count}</span> */}
          </div>

          <div className="table-wrapper">
            <table class="case-table">
              <thead>
                <tr>
                  <th className="col-title">Suit Number</th>
                  <th className="col-title">Case Title</th>
                  <th className="col-medium">Filing Type</th>
                  <th className="col-medium">Classification</th>
                  <th className="col-medium">Date Initiated</th>
                  <th className="col-medium">Status Level</th>

                  {tab != "processed" && <th>SLA</th>}
                  <th className="col-title">Details</th>

                  {tab != "processed" && <th className="col-action">Action</th>}
                </tr>
              </thead>
              <tbody>
                {cases?.map((opt, index) => {
                  const cc = Constants.getSlaTimeLeft(opt.slaExpire,holidays );
                  return (
                    <tr key={index}>
                      <td
                        style={{
                          backgroundColor: `${
                            Constants.getItemById(
                              frequentData?.casecategories,
                              opt.caseCategoryId,
                            )?.colour
                          }`,
                        }}
                      >
                        {(tab !== "processed"
                          ? opt.referenceNumber
                          : opt.caseNumber) || "N/A"}
                      </td>
                      <td>{opt.caseTitle || "N/A"}</td>
                      <td>
                        {Constants.getItemById(
                          frequentData?.casetype,
                          opt.caseTypeId,
                        )?.caseType1 || "N/A"}
                      </td>
                      <td>
                        {" "}
                        {Constants.getItemById(
                          frequentData?.casecategories,
                          opt.caseCategoryId,
                        )?.categoryTitle || "N/A"}
                      </td>
                      <td>
                        {" "}
                        {Constants.momentDate(opt.createdOn).format(
                          "DD MMM, YYYY",
                        ) || "N/A"}
                      </td>
                      <td>
                        {Constants.getItemById(
                          frequentData?.casestatuses,
                          opt.caseStatusId,
                        )?.description || "N/A"}
                      </td>
                      {tab != "processed" && (
                        <td>
                          <DeadlineBadge dateString={opt.slaExpire} />{" "}
                        </td>
                      )}

                      <td>
                        <JisButton
                          variant="plain"
                          // onClick={() => onContinue(opt, index)}
                          onClick={() => handleViewClick(opt.caseId)}
                        >
                          View
                        </JisButton>
                      </td>
                      {tab != "processed" && (
                        <td>
                          <JisButton
                            variant="plain"
                            onClick={() => onAdrLitigation(opt, index)}
                          >
                            Clear
                          </JisButton>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {cases?.length > 0 && (
            <Pagenated
              size={pageSize}
              total={count}
              maxPage={20}
              onPick={onPagePick}
              onChangePageSize={(k) => setPageSize(k)}
            />
          )}
        </div>
      )}
      <BackLoader open={loading} />

      {openCase && (
        <JisDialogForm title="Case Info" onClose={onCloseOpenCase}>
          <div>
            <CaseDetails
              caseId={active.caseId}
              data={null}
              token={token}
              initialtab="casedocuments"
            />
          </div>
        </JisDialogForm>
      )}

      {openOption && (
        <ClearOptionsModal
          setOpenOption={setOpenOption}
          isScreened={isScreened}
          onSave={onSave}
          active={active}
          isLiti={isLiti}
          setIsLitiation={setIsLitiation}
          isRework={isRework}
          setIsRework={setIsRework}
          processMode={processMode}
          setProcessMode={setProcessMode}
          option={option}
          onOptionChange={onOptionChange}
          frequentData={frequentData}
          claimTypes={claimTypes}
          selectedClaimTypes={selectedClaimTypes}
          setSelectedClaimTypes={setSelectedClaimTypes}
          documents={documents}
          onPreviewDoc={onPreviewDoc}
          rework_handleChange={rework_handleChange}
          err={err}
          onGenerateNumber={onGenerateNumber}
          onAddMissingDoc={onAddMissingDoc}
          selectedGaz={selectedGaz}
          gazettes={gazettes}
          missingDocs={missingDocs}
          showOmittedDocs={showOmittedDocs}
          setShowOmittedDocs={setShowOmittedDocs}
          onRemoveMissing={(id) =>
            setMissingDocs((prev) => prev.filter((d) => d.id !== id))
          }
          suitNumber={suitNumber}
        />
      )}

      {isDocPreview && previewUrl != "" && (
        <JisDialogForm
          title="Document Preview"
          onClose={() => setIsDocPreview(false)}
        >
          <div>
            <div style={{ height: "90vh" }}>
              {" "}
              <PdfViewer pdfUrl={previewUrl} />
            </div>
          </div>
        </JisDialogForm>
      )}
    </div>
  );
}

export default ACRScreen;
